var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashBackPriceNoteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_164_2658",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.86133C0 4.44305 3.58172 0.861328 8 0.861328C12.4164 0.865945 15.9954 4.44496 16 8.86133C16 13.2796 12.4183 16.8613 8 16.8613C3.58172 16.8613 0 13.2796 0 8.86133ZM1.33333 8.86133C1.33333 12.5432 4.3181 15.528 8 15.528C11.6801 15.5236 14.6623 12.5414 14.6667 8.86133C14.6667 5.17943 11.6819 2.19466 8 2.19466C4.3181 2.19466 1.33333 5.17943 1.33333 8.86133ZM9.33333 4.87923C9.33333 5.6255 8.73638 6.23046 8 6.23046C7.26362 6.23046 6.66667 5.6255 6.66667 4.87923C6.66667 4.13297 7.26362 3.528 8 3.528C8.73638 3.528 9.33333 4.13297 9.33333 4.87923ZM8 14.5257C8.61267 14.5257 9.33333 14.0224 9.33333 13.4015V8.1568C9.33333 7.53591 8.61267 7.03258 8 7.03258C7.38733 7.03258 6.66667 7.53591 6.66667 8.1568V13.4015C6.66667 14.0224 7.38733 14.5257 8 14.5257Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_164_2658)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6.66669,
    y: -5.66675,
    width: 29.3333,
    height: 29.3333,
    fill: "#02751A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashBackPriceNoteIcon);
export default __webpack_public_path__ + "static/media/cash-back-price-note-icon.01cb0665d4db143eee8c80bc3b1befd8.svg";
export { ForwardRef as ReactComponent };